/**
 * 请求成功状态码
 */
export const SUCCESS_CODE = 0

/**
 * 请求所有的状态码
 */
export const STATUS_CODE = [
  { code: 0, en: 'success', text: '成功' },
  { code: 10000, en: 'fail', text: '失败' },
  { code: 10001, en: 'param error', text: '创建失败，请检查提交的数据' },
  { code: 10002, en: 'auth error', text: '您还没有没有权限，请联系管理员' }
]

/**
 * 请求contentType
 */
export const CONTENT_TYPE: AxiosContentType = 'application/json'

/**
 * 请求超时时间
 */
export const REQUEST_TIMEOUT = 60000

/**
 * 不重定向白名单
 */
export const NO_REDIRECT_WHITE_LIST = ['/login']

/**
 * 不重置路由白名单
 */
export const NO_RESET_WHITE_LIST = ['Redirect', 'RedirectWrap', 'Login', 'NoFind', 'Root']

/**
 * 表格默认过滤列设置字段
 */
export const DEFAULT_FILTER_COLUMN = ['expand', 'selection']

/**
 * 是否根据headers->content-type自动转换数据格式
 */
export const TRANSFORM_REQUEST_DATA = true

/**
 * 全局图标前缀
 */
export const ICON_PREFIX = 'vi-'
